import { Controller } from "@hotwired/stimulus"
import { Sortable } from "sortablejs"
import { Turbo } from "@hotwired/turbo-rails"

// Drag-reorder the campaign sequence steps and persist the new order. Lives on
// the builder list inside the :campaign_sequence_builder frame and reconnects
// when that frame is repainted (the reorder response re-renders it with
// authoritative step numbers). (#218 phase 3)
//
// Targets: list (the <ol>), item (each <li>, carrying data-sequence-id)
// Value:   url (the reorder endpoint)
export default class extends Controller {
  static targets = ["list", "item"]
  static values = { url: String }

  connect() {
    this.sortable = Sortable.create(this.listTarget, {
      animation: 150,
      handle: ".drag-handle",
      onEnd: () => this.persist()
    })
  }

  disconnect() {
    this.sortable?.destroy()
    this.sortable = null
  }

  persist() {
    const ids = this.itemTargets.map((item) => item.dataset.sequenceId)
    fetch(this.urlValue, {
      method: "PATCH",
      headers: {
        "Content-Type": "application/json",
        "X-CSRF-Token": document.querySelector('meta[name="csrf-token"]')?.content,
        Accept: "text/vnd.turbo-stream.html"
      },
      body: JSON.stringify({ sequence_ids: ids })
    })
      .then((response) => response.text())
      .then((html) => Turbo.renderStreamMessage(html))
  }
}
